import React from 'react';
import { useTranslation } from 'react-i18next';
import { Video } from '../Video/Video';
import type { PickYourFiDeviceKey } from './HardwareFirstBelowFold';
import { moduleVideo } from './hardwareFirstVideos';
import styles from './HardwareFirstVideoModule.module.scss';

/**
 * The device's own footage, below the fold. Unlike the gallery slide this one waits behind a
 * scrim: the shopper scrolled into it rather than asking for it, and it sits directly under the
 * app carousel, so two things moving at once would fight.
 *
 * Cats have no footage of their own, so the module drops rather than showing a dog.
 */
export default function HardwareFirstVideoModule({ deviceKey }: { deviceKey: PickYourFiDeviceKey }) {
  const { t } = useTranslation();
  const video = moduleVideo(deviceKey);

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{t('hardware_first_see_it_in_action')}</h2>
      <div className={styles.frame}>
        <Video video={video} className={styles.video} />
      </div>
    </section>
  );
}
